import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { List , Checkbox } from 'semantic-ui-react';
import { changeUiState } from '../../actions/uiActions';

const styles = {
  serviceSelect : {
    display : 'flex',
    flexDirection : 'row',
    alignItems : 'space-between',
    justifyContent : 'space-between',
    paddingTop : '10px'
  }
}

class QuoteCart extends Component {
  shouldComponentUpdate(nextProps){
    const { quote } = this.props;
    return JSON.stringify(quote) !== JSON.stringify(nextProps.quote);
  }
  render(){
    const { string , quote , changeUiState } = this.props;
    const { software , hardware , totalPrice } = quote;
    return (
      <List divided>
        <List.Item><List.Header>{string['hardware']}</List.Header><List.List>{hardware.map((product,index)=><List.Item key={index}>{`${string[product.header]} x ${product.quantity}`}</List.Item>)}</List.List></List.Item>
        <List.Item><List.Header>{string['software']}</List.Header><List.List>{software.map((product,index)=><List.Item key={index}>{`${string[product.header]} x ${product.quantity}`}</List.Item>)}</List.List></List.Item>
        {(software.length > 0 & hardware.length > 0) ? <List.Item>
          <List.Header>{`${string['service']}(${string['laterCount']})`}</List.Header>
          <div style={styles.serviceSelect}>
            <p>{string['basicCs']}</p>
            <Checkbox toggle onClick={(event,{ checked })=>{
              const serviceSelectAction = (!checked === true) ?
                [{ keys : ['tempData','quote','service'] , value : [{ header : 'basicCs' , price : 0 , quantity : 1 }] }] :
                [{ keys : ['tempData','quote','service'] , value : [{ header : 'premiumCs' , price : totalPrice*0.25 , quantity : 1 }] }] ;
              changeUiState(serviceSelectAction);
            }}/>
            <p>{string['premiumCs']}</p>
          </div>
        </List.Item> : null}
      </List>
    );
  }
}

function mapStateToProps(state) {
  return {
    string : state.preference.string
  }
}

const mapDispatchToProps = (dispatch)=>bindActionCreators({ changeUiState },dispatch)

export default connect(mapStateToProps,mapDispatchToProps)(QuoteCart)



/** WEBPACK FOOTER **
 ** ./src/containers/price/quoteCart.js
 **/